<script setup lang="ts">
import { useAppDataStore } from '@stores/useAppDataStore.ts';
import { storeToRefs } from 'pinia';
import Button from '@components/Button.vue';
import Icon from '@components/Icon.vue';
import IconList from '@icons/ph_list.svg';
import IconQuestionCircle from '@icons/ph_question-circle.svg';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import TooltipClick from '@components/TooltipClick.vue';
import DesktopHelpMenu from '@app/layout/nav/desktop/components/menus/DesktopHelpMenu.vue';
import SearchLink from '@app/layout/nav/desktop/components/SearchLink.vue';

import AccountManagerContactChip from '@pages/selection-item/components/AccountManagerContactChip.vue';

const { toggleExpanded } = useNavbarStore();
const { accountManager } = storeToRefs(useAppDataStore());
</script>

<template>
  <div
    :class="[
      'h-full',
      'flex items-center justify-between'
    ]"
  >
    <div class="flex items-center gap-4">
      <Button
        variant="invisible"
        class="top-navbar-desktop-authenticated__menu-item"
        data-cy-ref="top-navbar-desktop__btn--expanded"
        @click="toggleExpanded"
      >
        <Icon
          :svg="IconList"
          width="24"
          height="24"
          fill="gray-darker"
        />
      </Button>

      <SearchLink data-cy-ref="top-navbar-desktop__link--search" />
    </div>

    <div class="flex items-center space-x-2">
      <AccountManagerContactChip
        v-if="accountManager"
        :account-manager="accountManager"
        data-cy-ref="top-navbar-desktop__account-manager"
      />

      <TooltipClick panel-class="top-navbar-desktop-authenticated__panel">
        <template #trigger>
          <Button
            class="top-navbar-desktop-authenticated__menu-item"
            data-cy-ref="top-navbar-desktop__btn--help"
          >
            <Icon
              :svg="IconQuestionCircle"
              width="24"
              height="24"
              fill="gray-darker"
            />
          </Button>
        </template>

        <template #panel="{ close }">
          <DesktopHelpMenu
            data-cy-ref="top-navbar-desktop__panel--help"
            @intercom-open="close"
          />
        </template>
      </TooltipClick>
    </div>
  </div>
</template>

<style scoped lang="scss">
.top-navbar-desktop-authenticated {
  &__menu-item {
    @apply border-0 w-fit p-3 flex items-center space-x-2 hover:bg-blue-lightest;
  }
}

:deep(.top-navbar-desktop-authenticated__panel) {
  @apply right-0 mt-1 rounded-lg px-2 py-4;
}
</style>
